import React__default from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import CloseIcon from '../Icons/CloseIcon.js';

var css_248z = ".Ps6Rc{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;font-size:20px;justify-content:space-between;max-width:420px;position:absolute;top:0;width:100%;z-index:2}[dir] .Ps6Rc{background-color:#fff;padding:24px}[dir=ltr] .Ps6Rc{left:0}[dir=rtl] .Ps6Rc{right:0}.Ps6Rc .g-Syt{fill:var(--ricos-settings-icons-color,#000)}[dir] .Ps6Rc .g-Syt{cursor:pointer}.Ps6Rc .g-Syt:hover{opacity:.5}";
var styles = {"settingsPanelHeader":"Ps6Rc","settingsPanelHeader_closeIcon":"g-Syt"};
styleInject(css_248z);

const SettingsPanelHeader = ({
  title,
  onClose,
  children,
  showCloseIcon = true
}) => {
  const onKeyPress = (e) => e.key === "Enter" && onClose();
  return /* @__PURE__ */ React__default.createElement("div", { className: styles.settingsPanelHeader }, /* @__PURE__ */ React__default.createElement("div", { className: styles.settingsPanelHeader_title }, children || title), /* @__PURE__ */ React__default.createElement("div", { className: styles.settingsPanelHeader_closeIcon }, showCloseIcon && /* @__PURE__ */ React__default.createElement(
    CloseIcon,
    {
      onClick: onClose,
      onKeyPress,
      tabIndex: 0,
      "data-hook": "settingsCloseIcon"
    }
  )));
};

export { SettingsPanelHeader as default };
//# sourceMappingURL=SettingsPanelHeader.js.map
